export const getAccessToken = () => {
  const token = localStorage.getItem('accessToken')
  if (!token || token === 'undefined' || token === 'null' || token === '""') {
    return null
  }
  return token
}

export const removeAccessToken = () => {
  localStorage.removeItem('accessToken')
  localStorage.removeItem('auth')
}
